import { gql } from 'graphql-tag'
import { fragmentModuleMedia } from '../../../../core/data-layer/modules/fragments'

export default gql`
  ${fragmentModuleMedia}
  fragment ProductUpdatesDetailShortFragment on PageProductUpdatesDetail {
    sys {
      id
    }
    title
    description
    date
    slug
    image {
      ...ModuleMediaFragment
    }
    product {
      sys {
        id
      }
      name
    }
  }
`
